import React from 'react'
import { Link } from 'react-router-dom'

export default function SidebarItems(props) {
    return props.items.map((item) => (
        <li className="nav-item" key={item.id}>
            <Link className={props.active === item.path ? "nav-link active" : "nav-link"} to={item.path}>
            <span data-feather="home"></span>
            {item.label}
            </Link>
        </li>
    ))
}
